<template>
  <div>
    <div class="alert alert-warning" role="alert">
      Making changes require your users to reload their web browser to have effect on the UI.
    </div>
    <div class="alert alert-primary" role="alert">
      Read/Write permissions become effective immediately.
    </div>
  </div>
</template>

<script>
export default {

}
</script>